import { Controller } from "@hotwired/stimulus"

// Shows the step-2 selector only when "specific" scope is chosen.
export default class extends Controller {
  static targets = ['scope', 'step2', 'step2Line']

  connect() {
    this.update()
  }

  update() {
    const specificSelected = this.scopeTargets.some((radio) => radio.checked && radio.value === 'specific')

    if (this.hasStep2Target) {
      this.step2Target.classList.toggle('hidden', !specificSelected)
    }

    if (this.hasStep2LineTarget) {
      this.step2LineTarget.classList.toggle('hidden', !specificSelected)
    }
  }
}